export enum ENavigationRoute {

    Login = 'login',
    Home = 'home',
    Error = 'error',
    Strategy = 'Strategy',
    StrategyDetail = 'strategy-detail',
    Order = 'order',
    Config = 'config',
    IntenventionList = 'my-interventions',
    Budget = 'budget',
    ResetPassword = 'resetPassword',
    Agency = 'agency'
}
